import React, { useState, useEffect } from "react";
import { MDBTable, MDBTableBody, MDBTableHead } from "mdbreact";

// Router
import { withRouter } from "react-router-dom";

// Redux
import { connect } from "react-redux";
import moment from "moment";

// UI Components
import { Loader } from "../../UI/Loaders/Loaders";
import Paginator from "../Pagination/Pagination.component";
import useBatchLoanRequestStatus from "../../custom-hooks/useBatchLoanRequestStatus";
import useAllAggregators from "../../custom-hooks/useAllAggregators";
import { accurateQuantifier } from "./../../helpers/accurateQuantifier";
import { formatMoney } from "../../helpers/formatter";
import { getTokenFromLocalStorage } from "../../helpers/localStorage";
import { BASE_URL } from "../../appConstants";
import { appInsights } from "../../config/appInsights";

const BatchLoanUploads = (props) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [size, setSize] = useState(100);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startDatePre, setStartDatePre] = useState("");
  const [endDatePre, setEndDatePre] = useState("");
  const [aggregatorId, setAggregatorId] = useState("");
  const [aggregatorIdPre, setAggregatorIdPre] = useState("");
  const [count, setCount] = useState(null);
  const [loanStatus, setLoanStatus] = useState(null);
  const [loanStatusPre, setLoanStatusPre] = useState(null);

  const resetTable = () => {
    setCount(null);
    setPageNumber(1);
  };

  const setFilterObject = (e) => {
    e.preventDefault();
    resetTable();
    if (startDatePre && endDatePre) {
      setStartDate(startDatePre);
      setEndDate(endDatePre);
    }
    setAggregatorId(aggregatorIdPre);
    setLoanStatus(loanStatusPre);
  };

  //  Life Cycle Hooks
  useEffect(() => {
    //  If user is not authenticates, redirect to login
    if (!props.isAuthenticated) {
      props.history.push("/login");
    }
  }, [props.history, props.isAuthenticated, props.loggedInUser]);

  //JSX Template
  let RenderedComponent = null;

  const { data, status, error } = useBatchLoanRequestStatus({
    Page: pageNumber,
    PageSize: size,
    FromDate: startDate,
    ToDate: endDate,
    AggregatorId: aggregatorId,
    Status: loanStatus,
  });

  if (data) {
    if (count === null) {
      setCount(data.totalCount);
    }
  }
  const {
    data: aggregatorData,
    status: aggregatorDataStatus,
    error: aggregatorDataError,
  } = useAllAggregators();
  const downLoadExcel = async (e) => {
    e.preventDefault();
    setFilterObject(e);
    let queryParams = "";
    if (startDatePre || endDatePre) {
      queryParams = `${
        queryParams ? queryParams + "&" : ""
      }FromDate=${startDatePre}&ToDate=${endDatePre}`;
    }
    if (aggregatorIdPre) {
      queryParams = `${
        queryParams ? queryParams + "&" : ""
      }AggregatorId=${aggregatorId}`;
    }
    if (loanStatusPre) {
      queryParams = `${
        queryParams ? queryParams + "&" : ""
      }loanStatus=${loanStatusPre}`;
    }
    let token = getTokenFromLocalStorage();

    await fetch(BASE_URL + `/eco/download_batch_loan_csv?${queryParams}`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: "Token " + token,
      },
      // body: JSON.stringify(data)
    })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          response.blob().then((blob) => {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `batch-loan-upload.csv`);
            link.click();
          });
        }
        if (response.status === 403 || response.status === 401) {
          localStorage.removeItem("sso_auth_token");
          this.props.history.push("/login");
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "BatchLoanUploads.jsx",
          },
        });
      });
  };
  const formatMessage = (message) => {
    try {
      if (message) {
        const returnedMessage = JSON.parse(message).message;
        return returnedMessage ? returnedMessage : null;
      } else {
        return null;
      }
    } catch (error) {
      appInsights.trackException({
        exception: error,
        properties: {
          fileName: "BatchLoanUploads.jsx",
        },
      });
      if (typeof message === "string") {
        return message;
      } else {
        return null;
      }
    }
  };
  // const fileName = `batch-loan-upload-${new Date().getFullYear()}-${new Date().getMonth()}-${new Date().getDate()}`;

  if (!data && status !== "loading") {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt">
            <i className="fas fa-bell" /> Unable to fetch Uploaded Loans
          </h4>
        </div>
      </div>
    );
  } else if (status === "loading" || aggregatorDataStatus === "loading") {
    RenderedComponent = (
      <Loader centered="true" text="Loading Uploaded Loans..." />
    );
  } else {
    if (error || aggregatorDataError) {
      RenderedComponent = (
        <div>
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There was an issue while fetching
              uploaded loans, Please Reload The Page{" "}
            </h4>
          </div>
        </div>
      );
    } else if (
      (data && data.data && data.data.length === 0) ||
      (data && !data.data)
    ) {
      RenderedComponent = (
        <div className="centerLoader">
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There are currently no uploaded
              loans.
            </h4>
          </div>
        </div>
      );
    } else {
      RenderedComponent = (
        <div className="row m-x-sm m-y-2 grid__padding">
          <div className="d-flex flex-row flex-wrap justify-content-between">
            {/* <div className="d-flex flex-row flex-start">
              <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-xls"
                className="btn login-btn"
                filename={fileName}
                sheet="tablexls"
                buttonText="Download as Excel"
              />
            </div> */}

            <form className="d-flex flex-row m-t-md" onSubmit={setFilterObject}>
              <div
                className="d-flex flex-row flex-wrap justify-content-start"
                style={{ alignItems: "flex-end" }}
              >
                <div className="m-l-1 m-r-1 m-b-1 form-group">
                  <label htmlFor="table-fetch">Start Date:</label>
                  <input
                    type="date"
                    className="form-control"
                    onChange={(e) => setStartDatePre(e.target.value)}
                    value={startDatePre}
                    max={moment(new Date()).format("YYYY-MM-DD")}
                    placeholder="YYYY/MM/DD"
                  />
                </div>

                <div className="m-l-1 m-r-1 m-b-1 form-group">
                  <label htmlFor="table-fetch">End Date:</label>
                  <input
                    type="date"
                    className="form-control"
                    onChange={(e) => setEndDatePre(e.target.value)}
                    value={endDatePre}
                    max={moment(new Date()).format("YYYY-MM-DD")}
                    placeholder="YYYY/MM/DD"
                  />
                </div>

                <div className="m-r-1 m-b-1 form-group">
                  <label htmlFor="table-fetch" className="d-block">
                    Status:
                  </label>
                  <select
                    onChange={(e) => setLoanStatusPre(e.target.value)}
                    id="table-fetch"
                    className="table-fetch-select"
                    value={loanStatusPre}
                  >
                    <option value="">All</option>
                    <option value={1}>Pending</option>
                    <option value={2}>Success</option>
                    <option value={3}>Failed</option>
                  </select>
                </div>

                <button className="zoom-element btn login-btn" type="submit">
                  Filter
                </button>
                <button
                  className="zoom-element btn login-btn  m-l-1"
                  onClick={downLoadExcel}
                >
                  Download as Excel
                </button>
              </div>
            </form>
          </div>
          <MDBTable responsive minimal="true" bordered hover id="table-to-xls">
            <MDBTableHead>
              <tr>
                <th>S/N</th>
                <th>Aggregator Name</th>
                <th>Borrower Name</th>
                <th>BVN</th>
                <th>Email</th>
                <th>Borrower Type</th>
                <th>Gender</th>
                <th>DOB</th>
                <th>Submitted Date</th>
                <th>Phone Number</th>
                <th>Amount</th>
                <th>Tenure</th>
                <th>Interest</th>
                <th>Batch Number</th>
                <th>Status</th>
                <th>Message</th>
              </tr>
            </MDBTableHead>
            <MDBTableBody>
              {data?.data.map((data, _id) => {
                const {
                  annualInterestRate,
                  borrowerType,
                  customerBVN,
                  emailAddress,
                  firstName,
                  lastName,
                  loanAmount,
                  gender,
                  phoneNumber,
                  statusName,
                  tenureInDays,
                  dateofBirth,
                  message,
                  aggregatorID,
                  currency,
                  batchNumber,
                  dateSubmitted,
                } = data;

                const aggregatorInQuestion = aggregatorData.find(
                  (aggregator) => {
                    return (
                      Number(aggregator.aggregator_id) === Number(aggregatorID)
                    );
                  }
                );

                return (
                  <tr key={_id}>
                    <td>{(pageNumber - 1) * size + (_id + 1)}</td>
                    <td>{aggregatorInQuestion?.biz_name}</td>
                    <td>{`${firstName} ${lastName}`}</td>
                    <td>{customerBVN}</td>
                    <td>{emailAddress}</td>
                    <td>
                      {borrowerType
                        ? borrowerType === 1
                          ? "Individual"
                          : "Corporate"
                        : null}
                    </td>
                    <td className="text-capitalize">{gender}</td>
                    <td>{dateofBirth && dateofBirth.substring(0, 10)}</td>
                    <td>{dateSubmitted && dateSubmitted.substring(0, 10)}</td>
                    <td>{phoneNumber}</td>
                    <td>{formatMoney(Number(loanAmount), currency)}</td>
                    <td>{accurateQuantifier(tenureInDays, "day")}</td>
                    <td>{annualInterestRate ? annualInterestRate : 0}%</td>
                    <td>{batchNumber}</td>
                    <td className="text-center">
                      <span
                        className={`btn btn-sm ${
                          statusName === "success"
                            ? "btn-success"
                            : statusName === "failed"
                            ? "btn-danger"
                            : "btn-warning"
                        }`}
                      >
                        {statusName}
                      </span>
                    </td>
                    <td>{formatMessage(message)}</td>
                  </tr>
                );
              })}
            </MDBTableBody>
          </MDBTable>
        </div>
      );
    }
  }

  return (
    <div className="datatable-wrapper">
      <div className="table-view speed-1x fadeInRight">
        {/*Audit Trail Header*/}
        <div className="block-header">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 dashboard-title flex__row">
              <h3 className="m-l-1">Batch Loan Uploads</h3>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="d-flex flex-row flex-wrap justify-content-end">
                <div className="m-r-1">
                  <label htmlFor="table-fetch" className="form-group">
                    Number of results:{" "}
                    <select
                      onChange={(e) => {
                        resetTable();
                        setSize(e.target.value);
                      }}
                      id="table-fetch"
                      className="table-fetch-select"
                      value={size}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={count * 2}>All</option>
                    </select>
                  </label>
                </div>
                <label htmlFor="table-fetch" className="form-group">
                  Showing results for:{" "}
                  <select
                    onChange={(e) => {
                      resetTable();
                      setAggregatorIdPre(e.target.value);
                    }}
                    id="table-fetch"
                    className="table-fetch-select"
                    style={{ maxWidth: "200px" }}
                    value={aggregatorIdPre}
                  >
                    <option value="">All aggregators</option>
                    {aggregatorData &&
                      aggregatorData.map((aggregator) => {
                        const { biz_name, aggregator_id } = aggregator;
                        return (
                          <option
                            value={Number(aggregator_id)}
                            key={aggregator_id}
                          >
                            {biz_name}
                          </option>
                        );
                      })}
                  </select>
                </label>
              </div>
            </div>
          </div>
        </div>

        {/*Datatable || Loader || Error Message*/}
        {RenderedComponent}

        <Paginator
          size={size}
          page={pageNumber}
          count={count}
          changeCurrentPage={(pageNumber) => setPageNumber(pageNumber)}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    authReducer: { isAuthenticated },
  } = state;

  return {
    isAuthenticated,
  };
};

export default withRouter(connect(mapStateToProps)(BatchLoanUploads));
